module.exports = __webpack_public_path__ + "img/yuan.4b810247.png";